import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import NotreProjet from './pages/NotreProjet';
import APropos from './pages/APropos';
import Contact from './pages/Contact';
import NousAider from './pages/NousAider';
import Inscription from './pages/Inscription';
import Verification from './pages/Verification';
import Login from './pages/Login';
import MonCompte from './pages/MonCompte';
import Admin from './pages/Admin';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import NotFound from './pages/NotFound';
import { Toaster } from './components/ui/toaster';
import { IntroOverlay, PageTransition } from './components/PageTransition';
import Chatbot from './components/Chatbot';
import { AuthProvider } from './contexts/AuthContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <IntroOverlay />
          <Layout>
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/notre-projet" element={<NotreProjet />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/nous-aider" element={<NousAider />} />
              <Route path="/inscription" element={<Inscription />} />
              <Route path="/verification" element={<Verification />} />
              <Route path="/connexion" element={<Login />} />
              <Route path="/mon-compte" element={<MonCompte />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PageTransition>
        </Layout>
        <Chatbot />
        <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
